// List of languages supported by the platform.
// Add any newly supported language here.
// It is expected that the files with the same name with json
// extensions would be found in the same directory as this.
const intlCollection = [
  "en",
  "es",
  "es-cl",
  "fr",
  "fr-ca",
  "zh-hans",
  "ja",
  "de",
  "ua",
  "ru",
  "th",
  "vi",
  "ar",
  "tr",
  "pt-br",
  "pt",
  "zh-hant",
  "ko",
  "zh-tw",
  "id",
  "it",
  "km",
  "my",
  "nan-tw",
  "ms",
  "bg",
  "nl",
  "ro",
  "bs",
  "he",
  "cs",
  "da",
  "el",
  "et",
  "fi",
  "hr",
  "hu",
  "lt",
  "lv",
  "no",
  "sk",
  "sr",
  "sv",
  "es-ar",
  "es-co",
  "es-cr",
  "es-sv",
  "es-gt",
  "es-hn",
  "es-ni",
  "es-pa",
  "es-pe"
];

// IntlLoader holds the functions which acts as asynchronous loaders
// to load any specific supported language at run-time.
/** @type {Record<string, () => Promise<{ default: Record<string, string> }>>} */
const _IntlLoader = {};
intlCollection.forEach(languageCode => {
  /**
   * Loader function which asynchronously loads the required language
   * and returns the JSON. Intentionally didn't made this as a getter because
   * we use to check if the language code exists in the object or not before
   * invoking the loader function.
   * @returns {Promise<{ default: Record<string, string> }>} Successful promise resolution returns the language JSON
   */
  _IntlLoader[languageCode] = () => {
    if (!import.meta.env.PROD) {
      console.log("Loading language strings for " + languageCode);
    }

    const asyncImport = import(`./language-${languageCode}.json`)
      .then(module => {
        console.log(`✅ Successfully loaded language: ${languageCode}`);
        return module;
      })
      .catch(error => {
        console.error(
          `❌ Failed to dynamically import language: ${languageCode}`,
          {
            error,
            errorMessage: error.message,
            errorName: error.name,
            importPath: `./language-${languageCode}.json`,
            isProdMode: import.meta.env.PROD,
            baseURL: import.meta.env.BASE_URL,
            currentOrigin:
              typeof window !== "undefined" ? window.location.origin : "N/A",
            currentPath:
              typeof window !== "undefined" ? window.location.pathname : "N/A"
          }
        );
        // Re-throw to let AsyncIntlProvider handle it
        throw error;
      });

    return asyncImport;
  };
});

export const IntlLoader = _IntlLoader;
